module.exports = __webpack_public_path__ + "static/media/trash.b6128269.svg";